import { axiosWalletRequest, METHOD } from '../api/Requests';

export const openAI = (prompt) => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    return axiosWalletRequest('Prompt/OpenAI', METHOD.POST, prompt, config);
}

export const openAIHistory = (prompt) => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    return axiosWalletRequest('Prompt/OpenAIHistorico', METHOD.POST, prompt, config);
}

